import surPlusTemp from './src/surPlusTemp.vue'

export default surPlusTemp
